import { Instagram, Facebook, Youtube, Linkedin, Twitter } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#121212] text-[#FBF9F5] mt-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-4 gap-12">
        <div>
          <div className="font-serif text-2xl tracking-[0.3em]">LEE BAG</div>
          <p className="mt-4 text-sm text-[#8C867D] leading-relaxed">Timeless elegance. Handcrafted Indian leather luxury.</p>
          <p className="mt-6 text-xs tracking-[0.2em] uppercase text-[#C5A059]">Join our world of luxury</p>
          <form className="mt-3 flex gap-0 border-b border-[#27272A]">
            <input placeholder="Your email" data-testid="footer-newsletter-input" className="bg-transparent flex-1 py-2 text-sm placeholder:text-[#55524D] focus:outline-none" />
            <button type="button" data-testid="footer-newsletter-submit" className="text-xs uppercase tracking-[0.2em] text-[#C5A059] hover:text-white">Subscribe</button>
          </form>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.25em] text-[#C5A059] mb-4">Customer Care</h4>
          <ul className="space-y-2 text-sm text-[#8C867D]">
            <li>Contact Us</li><li>Shipping</li><li>Returns</li><li>FAQs</li><li>Order Tracking</li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.25em] text-[#C5A059] mb-4">About</h4>
          <ul className="space-y-2 text-sm text-[#8C867D]">
            <li>Our Story</li><li>Brand</li><li>Careers</li><li>Authenticity</li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.25em] text-[#C5A059] mb-4">Follow</h4>
          <div className="flex gap-4">
            <a href="https://instagram.com/leebag.lb" data-testid="footer-social-instagram"><Instagram size={18} /></a>
            <a href="https://facebook.com/leebag.lb" data-testid="footer-social-facebook"><Facebook size={18} /></a>
            <a href="https://twitter.com/LeebagLB" data-testid="footer-social-twitter"><Twitter size={18} /></a>
            <a href="#" data-testid="footer-social-linkedin"><Linkedin size={18} /></a>
            <a href="#" data-testid="footer-social-youtube"><Youtube size={18} /></a>
          </div>
          <p className="mt-6 text-xs text-[#55524D]">© 2026 LEE BAG. All rights reserved.</p>
        </div>
      </div>
      <div className="border-t border-[#27272A] py-4 text-center text-[10px] uppercase tracking-[0.25em] text-[#55524D]">
        Privacy Policy · Terms & Conditions · Refund Policy · Shipping Policy
      </div>
    </footer>
  );
}
